import { Input } from "@headlessui/react";
import React, { useState } from "react";

interface TagInputProps {
    tags: string[];
    onChange: (tags: string[]) => void;
    placeholder?: string;
    className?: string;
}

const TagInput: React.FC<TagInputProps> = ({ tags, onChange, placeholder, className }) => {
    const [draft, setDraft] = useState("");

    const addTag = () => {
        const value = draft.trim();
        if (value && !tags.includes(value)) {
            onChange([...tags, value]);
        }
        setDraft("");
    };

    const removeTag = (tag: string) => {
        onChange(tags.filter((t) => t !== tag));
    };

    return (
        <div className={`w-full  border border-primary-subtle rounded-lg flex flex-wrap items-center px-3 py-3  gap-2 ${className ?? 'bg-transparent'}  px-2  transition-colors`}>
            {tags.map((tag) => (
                <span
                    key={tag}
                    className="flex items-center gap-1 bg-blue-500/20 text-blue-300 text-xs rounded-full px-2 py-1"
                >
                    {tag}
                    <button
                        type="button"
                        onClick={() => removeTag(tag)}
                        className="hover:text-red-400 transition-colors"
                    >
                        ×
                    </button>
                </span>
            ))}
            <Input
                type={'text'}
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        addTag();
                    } else if (e.key === "Backspace" && !draft && tags.length) {
                        removeTag(tags[tags.length - 1]);
                    }
                }}
                placeholder={tags.length ? "" : placeholder ?? "Add a tag and press Enter"}
                className={`w-full  focus:ring-0 focus:outline-none 
                            flex-1 min-w-[120px] text-sm text-neutral h-[36px] placeholder:font-normal placeholder:text-base placeholder:text-[#374151] rounded-lg ${className ?? 'bg-transparent'}   transition-colors duration-200`}
            />

        </div>
    );
};

export default TagInput;
